"use client";
import React from "react";
import dynamic from "next/dynamic";
const Filters = dynamic(() => import("./Filters"), { ssr: true });

type Category = "industries" | "projectTypes" | "technologies";

interface Option {
  name: string;
  slug: string;
}
interface DrawerProps {
  isOpen: boolean;
  isChanged: boolean;
  onClose: () => void;
  selectedFilters: any;
  availableFilters: Record<Category, Option[]>;
  onApply: (applied: Record<string, string[]>) => void;
}

const FilterDrawer: React.FC<DrawerProps> = ({ isOpen,
  isChanged,
  onClose,
  onApply,
  availableFilters,
  selectedFilters,
}) => {
  React.useEffect(() => {
    if (isOpen) {
      document.body.classList.add("overflow-y-hidden-no");
      document.body.style.overflow = "hidden";
      // Additional lock for mobile browsers to prevent "motion"
      document.body.style.position = "fixed";
      document.body.style.width = "100%";
    } else {
      document.body.classList.remove("overflow-y-hidden-no");
      document.body.style.overflow = "auto";
      document.body.style.position = "";
      document.body.style.width = "";
    }
    return () => {
      document.body.classList.remove("overflow-y-hidden-no");
      document.body.style.overflow = "auto";
      document.body.style.position = "";
      document.body.style.width = "";
    };
  }, [isOpen]);

  return (
    <>
      {/* Overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black/40 z-40 touch-none" 
          onClick={onClose} 
        />
      )}

      {/* Drawer — starts below the fixed header (80px) and fills the rest of the screen */}
      <div
        className={`fixed top-[80px] left-0 right-0 h-[calc(100vh-80px)] w-full bg-white shadow-lg z-50 transform transition-transform duration-300 ${isOpen ? "translate-y-0" : "translate-y-full"
          }`}
      >
        <Filters
          onApply={onApply}
          onClose={onClose}
          isChanged={isChanged}
          selectedFilters={selectedFilters}
          availableFilters={availableFilters}
        />
      </div>
    </>
  );
};
export default FilterDrawer;
